{
    "ManageCustomRoles_Title": "Adicionar modelo de função personalizada",
    "ManageCustomRoles_Role_Name": "Nome do modelo de função",
    "ManageCustomRoles_Description": "Descrição",
    "ManageCustomRoles_Cancel": "Cancelar",
    "ManageCustomRoles_Help": "Ajuda",
    "ManageCustomRoles_Save": "Guardar",
    "NAME": "ManageCustomRoles"
}